var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sidebar-wrapper" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "phases-title-column pt-6 pb-2",
              attrs: { cols: "6" },
            },
            [
              _c("v-label", [
                _vm._v(" " + _vm._s(_vm.modelName) + " "),
                _vm.modelName ? _c("br") : _vm._e(),
                _vm._v(" Phases / Activity Events "),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-6 pb-2 text-right", attrs: { cols: "6" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-4 px-0",
                  attrs: {
                    outlined: !_vm.errorsOnlyFilter,
                    width: "36px",
                    "min-width": "36px",
                    color: "primary",
                    disabled:
                      _vm.disableErrorButtons() && !_vm.errorsOnlyFilter,
                    title: "Only show errors",
                    right: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleErrorsOnlyFilter()
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { attrs: { color: _vm.errorsOnlyFilter ? "white" : "" } },
                    [_vm._v("warning")]
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mr-4 px-0",
                  attrs: {
                    width: "36px",
                    "min-width": "36px",
                    color: "primary",
                    outlined: !_vm.listMode,
                    right: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleListMode()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("format_list_numbered")])],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mr-4 px-0",
                  attrs: {
                    width: "36px",
                    "min-width": "36px",
                    color: "error",
                    right: "",
                    outlined: "",
                    title: "Close Details",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("clear-selected-job")
                    },
                  },
                },
                [_c("v-icon", [_vm._v(" mdi-arrow-right ")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [_c("v-label", [_vm._v("Errors")])],
            1
          ),
          _c("v-col", { attrs: { cols: "6" } }, [
            _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      icon: "",
                      disabled: _vm.disableErrorButtons(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectFirstError()
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("first_page")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      icon: "",
                      disabled: _vm.disableErrorButtons(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPreviousError()
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("chevron_left")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      icon: "",
                      disabled: _vm.disableErrorButtons(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectNextError()
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("chevron_right")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      icon: "",
                      disabled: _vm.disableErrorButtons(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectLastError()
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("last_page")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-label", [_vm._v(" Events Sort ")]),
              _c(
                "v-btn",
                {
                  staticClass: "activity-event-sort-btn",
                  attrs: { text: "", "x-small": "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleActivityEventSort()
                    },
                  },
                },
                [
                  _vm.activityEventSortDirection === "asc"
                    ? _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(" arrow_upward "),
                      ])
                    : _vm._e(),
                  _vm.activityEventSortDirection === "desc"
                    ? _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(" arrow_downward "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.listMode
        ? _c(
            "v-col",
            { staticClass: "scroll-pane body-2", attrs: { cols: "12" } },
            _vm._l(_vm.getListModeEvents(), function (event) {
              return _c(
                "v-row",
                {
                  key: event.id,
                  ref: "list" + event.id,
                  refInFor: true,
                  class:
                    event === _vm.selectedEvent ? "selected" : "unselected",
                  attrs: { dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.selectEvent(event, false)
                    },
                  },
                },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "1" } },
                    [
                      event && event.isSuccessful
                        ? _c(
                            "v-avatar",
                            {
                              staticClass: "float-left",
                              attrs: {
                                size: "16",
                                color:
                                  event.warningCount > 0 ||
                                  event.exceptionCount > 0
                                    ? "warning"
                                    : "success",
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { "x-small": "", dark: "" } },
                                [_vm._v("done")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-avatar",
                            { attrs: { size: "16", color: "error" } },
                            [
                              _c(
                                "v-icon",
                                { attrs: { "x-small": "", dark: "" } },
                                [_vm._v("warning")]
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "overflow-hidden", attrs: { cols: "5" } },
                    [
                      _c(
                        "span",
                        {
                          attrs: {
                            title: _vm.getEventActivityDefinitionName(event),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.getEventActivityDefinitionName(event))
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _c("div", { staticClass: "float-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.getEventType(event.activityEventTypeId)) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "float-right" }, [
                      _vm._v(" " + _vm._s(_vm.displayEventDT(event)) + " "),
                    ]),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      !_vm.listMode && _vm.selectedJob[0].eventsLoaded
        ? _c(
            "v-expansion-panels",
            {
              staticClass: "left-icon scroll-pane body-2",
              attrs: { flat: "", accordion: "", multiple: "" },
              model: {
                value: _vm.etlPanels,
                callback: function ($$v) {
                  _vm.etlPanels = $$v
                },
                expression: "etlPanels",
              },
            },
            _vm._l(_vm.pipelinePhaseTypes, function (phaseType) {
              return _c(
                "v-expansion-panel",
                { key: phaseType },
                [
                  _c("v-expansion-panel-header", { staticClass: "pl-10" }, [
                    _vm._v(_vm._s(_vm.getPipelinePhaseName(phaseType))),
                  ]),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "v-expansion-panels",
                        {
                          attrs: { accordion: "", flat: "", multiple: "" },
                          model: {
                            value: _vm.phaseTypePanels[phaseType - 1],
                            callback: function ($$v) {
                              _vm.$set(_vm.phaseTypePanels, phaseType - 1, $$v)
                            },
                            expression: "phaseTypePanels[phaseType - 1]",
                          },
                        },
                        _vm._l(
                          _vm.getPhaseDefinitions(
                            phaseType,
                            _vm.errorsOnlyFilter,
                            _vm.selectedJob[0]
                          ),
                          function (ad, index) {
                            return _c(
                              "v-expansion-panel",
                              {
                                key: ad.id.toString() + index.toString(),
                                staticClass: "dense",
                                attrs: { "data-index": index },
                                on: {
                                  click: function ($event) {
                                    return _vm.expandedActivityDefinitionPanel(
                                      ad.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.expandDefinition(
                                          phaseType,
                                          ad
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-hover", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ hover }) {
                                              return [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "pl-5",
                                                    class:
                                                      _vm.selectedDefinition ===
                                                        ad || hover
                                                        ? "selected"
                                                        : "unselected",
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      { attrs: { cols: "1" } },
                                                      [
                                                        ad.status === 2
                                                          ? _c(
                                                              "v-avatar",
                                                              {
                                                                staticClass:
                                                                  "float-left",
                                                                attrs: {
                                                                  size: "16",
                                                                  color:
                                                                    ad.warningCount >
                                                                      0 ||
                                                                    ad.exceptionCount >
                                                                      0
                                                                      ? "warning"
                                                                      : "success",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      dark: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "done"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        ad.status === 1
                                                          ? _c(
                                                              "v-avatar",
                                                              {
                                                                staticClass:
                                                                  "rotate float-left",
                                                                attrs: {
                                                                  size: "16",
                                                                  color:
                                                                    ad.exceptionCount >
                                                                    0
                                                                      ? "error"
                                                                      : "primary",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      dark: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "update"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        ad.status === 3
                                                          ? _c(
                                                              "v-avatar",
                                                              {
                                                                staticClass:
                                                                  "float-left",
                                                                attrs: {
                                                                  size: "16",
                                                                  color:
                                                                    "error",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      dark: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "warning"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        ad.status === 4
                                                          ? _c(
                                                              "v-avatar",
                                                              {
                                                                staticClass:
                                                                  "float-left",
                                                                attrs: {
                                                                  size: "16",
                                                                  color: "grey",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      dark: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "remove"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "no-indent",
                                                        attrs: { cols: "10" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-menu",
                                                          {
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                    attrs,
                                                                  }) {
                                                                    return [
                                                                      ad.isReplayable
                                                                        ? _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              _vm._b(
                                                                                {
                                                                                  staticClass:
                                                                                    "float-left ml-1 mr-4 ellipses-btn",
                                                                                  class:
                                                                                    ad.isReplayable &&
                                                                                    _vm
                                                                                      .selectedJob[0]
                                                                                      .replayedDefinitionIds &&
                                                                                    _vm.selectedJob[0].replayedDefinitionIds.indexOf(
                                                                                      ad.id
                                                                                    ) ===
                                                                                      -1 &&
                                                                                    (hover ||
                                                                                      _vm.showEllipses(
                                                                                        ad,
                                                                                        index
                                                                                      ))
                                                                                      ? ""
                                                                                      : "hide-btn",
                                                                                  attrs:
                                                                                    {
                                                                                      height:
                                                                                        "16",
                                                                                      width:
                                                                                        "16",
                                                                                      icon: "",
                                                                                    },
                                                                                },
                                                                                "v-btn",
                                                                                attrs,
                                                                                false
                                                                              ),
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                [
                                                                                  _vm._v(
                                                                                    "more_horiz"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "v-list",
                                                              [
                                                                ad.eventsReplayable
                                                                  ? _c(
                                                                      "v-list-item",
                                                                      {
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          disabled:
                                                                            ad.isReplayable &&
                                                                            ad.workflowId ===
                                                                              0,
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.sendReplayRequest(
                                                                                _vm
                                                                                  .selectedJob[0]
                                                                                  .id,
                                                                                ad.id,
                                                                                true
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          [
                                                                            ad.isReplayable &&
                                                                            ad.workflowId ===
                                                                              0
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      " Replay Failed " +
                                                                                        _vm._s(
                                                                                          ad.name
                                                                                        ) +
                                                                                        " Events "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Replay Event"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                !ad.eventsReplayable
                                                                  ? _c(
                                                                      "v-list-item",
                                                                      {
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.sendReplayRequest(
                                                                                _vm
                                                                                  .selectedJob[0]
                                                                                  .id,
                                                                                ad.id,
                                                                                false
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          [
                                                                            _vm._v(
                                                                              "Replay + all subsequent"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(ad.name) +
                                                            " "
                                                        ),
                                                        _vm.selectedJob[0]
                                                          .replayedDefinitionIds &&
                                                        _vm.selectedJob[0].replayedDefinitionIds.indexOf(
                                                          ad.id
                                                        ) > -1
                                                          ? _c("sup", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    "(" +
                                                                      _vm.selectedJob[0].replayedDefinitionIds.filter(
                                                                        (x) =>
                                                                          x ===
                                                                          ad.id
                                                                      ).length +
                                                                      ")"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  [
                                    _vm.selectedJob[0].replayedDefinitionIds &&
                                    _vm.selectedJob[0].replayedDefinitionIds.indexOf(
                                      ad.id
                                    ) > -1
                                      ? _c(
                                          "v-expansion-panels",
                                          {
                                            attrs: {
                                              accordion: "",
                                              flat: "",
                                              multiple: "",
                                            },
                                          },
                                          _vm._l(
                                            ad.replays,
                                            function (replay, index) {
                                              return _c(
                                                "v-expansion-panel",
                                                { key: index },
                                                [
                                                  _c(
                                                    "v-expansion-panel-header",
                                                    [
                                                      _c("v-hover", {
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                hover,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-row",
                                                                    {
                                                                      staticClass:
                                                                        "my-0 pl-5",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "1",
                                                                            },
                                                                        },
                                                                        [
                                                                          replay.status ===
                                                                          2
                                                                            ? _c(
                                                                                "v-avatar",
                                                                                {
                                                                                  staticClass:
                                                                                    "float-left",
                                                                                  attrs:
                                                                                    {
                                                                                      size: "16",
                                                                                      color:
                                                                                        replay.hasErrors
                                                                                          ? "warning"
                                                                                          : "success",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          dark: "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "done"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          replay.status ===
                                                                          1
                                                                            ? _c(
                                                                                "v-avatar",
                                                                                {
                                                                                  staticClass:
                                                                                    "rotate float-left",
                                                                                  attrs:
                                                                                    {
                                                                                      size: "16",
                                                                                      color:
                                                                                        replay.hasErrors
                                                                                          ? "error"
                                                                                          : "primary",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          dark: "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "update"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          replay.status ===
                                                                          3
                                                                            ? _c(
                                                                                "v-avatar",
                                                                                {
                                                                                  staticClass:
                                                                                    "float-left",
                                                                                  attrs:
                                                                                    {
                                                                                      size: "16",
                                                                                      color:
                                                                                        "error",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          dark: "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "warning"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          replay.status ===
                                                                          4
                                                                            ? _c(
                                                                                "v-avatar",
                                                                                {
                                                                                  staticClass:
                                                                                    "float-left",
                                                                                  attrs:
                                                                                    {
                                                                                      size: "16",
                                                                                      color:
                                                                                        "grey",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          dark: "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "remove"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "v-col",
                                                                        {
                                                                          staticClass:
                                                                            "no-indent",
                                                                          attrs:
                                                                            {
                                                                              cols: "10",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-menu",
                                                                            {
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "activator",
                                                                                      fn: function ({
                                                                                        on,
                                                                                        attrs,
                                                                                      }) {
                                                                                        return [
                                                                                          ad.isReplayable
                                                                                            ? _c(
                                                                                                "v-btn",
                                                                                                _vm._g(
                                                                                                  _vm._b(
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "float-left ml-1 mr-4 ellipses-btn",
                                                                                                      class:
                                                                                                        index ===
                                                                                                          ad
                                                                                                            .replays
                                                                                                            .length -
                                                                                                            1 &&
                                                                                                        (hover ||
                                                                                                          _vm.showEllipses(
                                                                                                            ad,
                                                                                                            index
                                                                                                          ))
                                                                                                          ? ""
                                                                                                          : "hide-btn",
                                                                                                      attrs:
                                                                                                        {
                                                                                                          height:
                                                                                                            "16",
                                                                                                          width:
                                                                                                            "16",
                                                                                                          icon: "",
                                                                                                        },
                                                                                                    },
                                                                                                    "v-btn",
                                                                                                    attrs,
                                                                                                    false
                                                                                                  ),
                                                                                                  on
                                                                                                ),
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-icon",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "more_horiz"
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-item",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          dense:
                                                                                            "",
                                                                                          disabled:
                                                                                            ad.isReplayable &&
                                                                                            ad.workflowId ===
                                                                                              0,
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.sendReplayRequest(
                                                                                              _vm
                                                                                                .selectedJob[0]
                                                                                                .id,
                                                                                              ad.id,
                                                                                              true
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-list-item-title",
                                                                                        [
                                                                                          ad.isReplayable &&
                                                                                          ad.workflowId ===
                                                                                            0
                                                                                            ? _c(
                                                                                                "span",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Replay Failed " +
                                                                                                      _vm._s(
                                                                                                        ad.name
                                                                                                      ) +
                                                                                                      " Events "
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                  !ad.eventsReplayable
                                                                                    ? _c(
                                                                                        "v-list-item",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              dense:
                                                                                                "",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.sendReplayRequest(
                                                                                                  _vm
                                                                                                    .selectedJob[0]
                                                                                                    .id,
                                                                                                  ad.id,
                                                                                                  false
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-list-item-title",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Replay + all subsequent"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                replay.name
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-expansion-panel-content",
                                                    [
                                                      replay.events.length > 0
                                                        ? _c(
                                                            "div",
                                                            _vm._l(
                                                              replay.events,
                                                              function (event) {
                                                                return _c(
                                                                  "v-hover",
                                                                  {
                                                                    key: event.id,
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "default",
                                                                            fn: function ({
                                                                              hover,
                                                                            }) {
                                                                              return [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    ref:
                                                                                      "tree" +
                                                                                      event.id,
                                                                                    refInFor: true,
                                                                                    class:
                                                                                      hover ||
                                                                                      event ===
                                                                                        _vm.selectedEvent
                                                                                        ? "selected"
                                                                                        : "unselected",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.selectEvent(
                                                                                            event,
                                                                                            false
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-row",
                                                                                      {
                                                                                        staticClass:
                                                                                          "my-0",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-col",
                                                                                          {
                                                                                            staticClass:
                                                                                              "pr-0",
                                                                                            attrs:
                                                                                              {
                                                                                                cols: "2",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            event &&
                                                                                            event.isSuccessful
                                                                                              ? _c(
                                                                                                  "v-avatar",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "float-left ml-3",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        size: "16",
                                                                                                        color:
                                                                                                          event.warningCount >
                                                                                                            0 ||
                                                                                                          event.exceptionCount >
                                                                                                            0
                                                                                                            ? "warning"
                                                                                                            : "success",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "v-icon",
                                                                                                      {
                                                                                                        attrs:
                                                                                                          {
                                                                                                            "x-small":
                                                                                                              "",
                                                                                                            dark: "",
                                                                                                          },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "done"
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              : _c(
                                                                                                  "v-avatar",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "float-left ml-3",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        size: "16",
                                                                                                        color:
                                                                                                          "error",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "v-icon",
                                                                                                      {
                                                                                                        attrs:
                                                                                                          {
                                                                                                            "x-small":
                                                                                                              "",
                                                                                                            dark: "",
                                                                                                          },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "warning"
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ],
                                                                                                  1
                                                                                                ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        _c(
                                                                                          "v-col",
                                                                                          {
                                                                                            staticClass:
                                                                                              "pl-1 pr-0",
                                                                                            attrs:
                                                                                              {
                                                                                                cols: "4",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "text-left",
                                                                                              },
                                                                                              [
                                                                                                _vm.showEventEllipses(
                                                                                                  ad,
                                                                                                  event
                                                                                                )
                                                                                                  ? _c(
                                                                                                      "v-menu",
                                                                                                      {
                                                                                                        scopedSlots:
                                                                                                          _vm._u(
                                                                                                            [
                                                                                                              {
                                                                                                                key: "activator",
                                                                                                                fn: function ({
                                                                                                                  on,
                                                                                                                  attrs,
                                                                                                                }) {
                                                                                                                  return [
                                                                                                                    _c(
                                                                                                                      "v-btn",
                                                                                                                      _vm._g(
                                                                                                                        _vm._b(
                                                                                                                          {
                                                                                                                            staticClass:
                                                                                                                              "float-left ml-1 mr-4 ellipses-btn",
                                                                                                                            class:
                                                                                                                              ad.workflowId ===
                                                                                                                              0
                                                                                                                                ? ""
                                                                                                                                : "hide-btn",
                                                                                                                            attrs:
                                                                                                                              {
                                                                                                                                height:
                                                                                                                                  "16",
                                                                                                                                width:
                                                                                                                                  "16",
                                                                                                                                icon: "",
                                                                                                                              },
                                                                                                                          },
                                                                                                                          "v-btn",
                                                                                                                          attrs,
                                                                                                                          false
                                                                                                                        ),
                                                                                                                        on
                                                                                                                      ),
                                                                                                                      [
                                                                                                                        _c(
                                                                                                                          "v-icon",
                                                                                                                          [
                                                                                                                            _vm._v(
                                                                                                                              "more_horiz"
                                                                                                                            ),
                                                                                                                          ]
                                                                                                                        ),
                                                                                                                      ],
                                                                                                                      1
                                                                                                                    ),
                                                                                                                  ]
                                                                                                                },
                                                                                                              },
                                                                                                            ],
                                                                                                            null,
                                                                                                            true
                                                                                                          ),
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "v-list",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "v-list-item",
                                                                                                              {
                                                                                                                attrs:
                                                                                                                  {
                                                                                                                    dense:
                                                                                                                      "",
                                                                                                                  },
                                                                                                                on: {
                                                                                                                  click:
                                                                                                                    function (
                                                                                                                      $event
                                                                                                                    ) {
                                                                                                                      return _vm.sendReplayRequest(
                                                                                                                        _vm
                                                                                                                          .selectedJob[0]
                                                                                                                          .id,
                                                                                                                        ad.id,
                                                                                                                        true,
                                                                                                                        event.id
                                                                                                                      )
                                                                                                                    },
                                                                                                                },
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "v-list-item-title",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      "Replay Event "
                                                                                                                    ),
                                                                                                                  ]
                                                                                                                ),
                                                                                                              ],
                                                                                                              1
                                                                                                            ),
                                                                                                            ad.id ===
                                                                                                              _vm
                                                                                                                .ActivityDefinitionIds
                                                                                                                .Bim360Publish &&
                                                                                                            event.activityEventTypeId ===
                                                                                                              _vm
                                                                                                                .ActivityEventType
                                                                                                                .Started
                                                                                                              ? _c(
                                                                                                                  "v-list-item",
                                                                                                                  {
                                                                                                                    attrs:
                                                                                                                      {
                                                                                                                        dense:
                                                                                                                          "",
                                                                                                                      },
                                                                                                                    on: {
                                                                                                                      click:
                                                                                                                        function (
                                                                                                                          $event
                                                                                                                        ) {
                                                                                                                          return _vm.sendReplayRequestWithCompletedReferences(
                                                                                                                            _vm
                                                                                                                              .selectedJob[0]
                                                                                                                              .id,
                                                                                                                            ad.id,
                                                                                                                            true,
                                                                                                                            event.id
                                                                                                                          )
                                                                                                                        },
                                                                                                                    },
                                                                                                                  },
                                                                                                                  [
                                                                                                                    _c(
                                                                                                                      "v-list-item-title",
                                                                                                                      [
                                                                                                                        _vm._v(
                                                                                                                          "Replay with Completed References"
                                                                                                                        ),
                                                                                                                      ]
                                                                                                                    ),
                                                                                                                  ],
                                                                                                                  1
                                                                                                                )
                                                                                                              : _vm._e(),
                                                                                                          ],
                                                                                                          1
                                                                                                        ),
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      _vm.getEventType(
                                                                                                        event.activityEventTypeId
                                                                                                      )
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ],
                                                                                              1
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "v-col",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                cols: "6",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "text-right",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      _vm.displayEventDT(
                                                                                                        event
                                                                                                      )
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                                _vm.getMaxTelemetryTime(
                                                                                                  event
                                                                                                ) &&
                                                                                                event ===
                                                                                                  _vm.selectedEvent
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "text-caption",
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "v-icon",
                                                                                                          {
                                                                                                            attrs:
                                                                                                              {
                                                                                                                "x-small":
                                                                                                                  "",
                                                                                                              },
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "hourglass_empty"
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              _vm.getMaxTelemetryTime(
                                                                                                                event
                                                                                                              )
                                                                                                            ) +
                                                                                                            " "
                                                                                                        ),
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _c("div", [
                                                            _vm._v("No Events"),
                                                          ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._l(ad.events, function (event) {
                                          return _c("v-hover", {
                                            key: event.id,
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ hover }) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          ref:
                                                            "tree" + event.id,
                                                          refInFor: true,
                                                          class:
                                                            event ===
                                                              _vm.selectedEvent ||
                                                            hover
                                                              ? "selected"
                                                              : "unselected",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectEvent(
                                                                event,
                                                                false
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "my-0",
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pr-0",
                                                                  attrs: {
                                                                    cols: "1",
                                                                  },
                                                                },
                                                                [
                                                                  event &&
                                                                  event.isSuccessful
                                                                    ? _c(
                                                                        "v-avatar",
                                                                        {
                                                                          staticClass:
                                                                            "float-left ml-3",
                                                                          attrs:
                                                                            {
                                                                              size: "16",
                                                                              color:
                                                                                event.warningCount >
                                                                                  0 ||
                                                                                event.exceptionCount >
                                                                                  0
                                                                                  ? "warning"
                                                                                  : "success",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  "x-small":
                                                                                    "",
                                                                                  dark: "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "done"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _c(
                                                                        "v-avatar",
                                                                        {
                                                                          staticClass:
                                                                            "float-left ml-3",
                                                                          attrs:
                                                                            {
                                                                              size: "16",
                                                                              color:
                                                                                "error",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  "x-small":
                                                                                    "",
                                                                                  dark: "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "warning"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pl-0",
                                                                  attrs: {
                                                                    cols: "5",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-left pl-6",
                                                                    },
                                                                    [
                                                                      _vm.showEventEllipses(
                                                                        ad,
                                                                        event
                                                                      )
                                                                        ? _c(
                                                                            "v-menu",
                                                                            {
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "activator",
                                                                                      fn: function ({
                                                                                        on,
                                                                                        attrs,
                                                                                      }) {
                                                                                        return [
                                                                                          _c(
                                                                                            "v-btn",
                                                                                            _vm._g(
                                                                                              _vm._b(
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "float-left ml-1 mr-4 ellipses-btn",
                                                                                                  class:
                                                                                                    ad.workflowId ===
                                                                                                    0
                                                                                                      ? ""
                                                                                                      : "hide-btn",
                                                                                                  attrs:
                                                                                                    {
                                                                                                      height:
                                                                                                        "16",
                                                                                                      width:
                                                                                                        "16",
                                                                                                      icon: "",
                                                                                                    },
                                                                                                },
                                                                                                "v-btn",
                                                                                                attrs,
                                                                                                false
                                                                                              ),
                                                                                              on
                                                                                            ),
                                                                                            [
                                                                                              _c(
                                                                                                "v-icon",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "more_horiz"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-item",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          dense:
                                                                                            "",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.sendReplayRequest(
                                                                                              _vm
                                                                                                .selectedJob[0]
                                                                                                .id,
                                                                                              ad.id,
                                                                                              true,
                                                                                              event.id
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-list-item-title",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Replay Event "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                  ad.id ===
                                                                                    _vm
                                                                                      .ActivityDefinitionIds
                                                                                      .Bim360Publish &&
                                                                                  event.activityEventTypeId ===
                                                                                    _vm
                                                                                      .ActivityEventType
                                                                                      .Started
                                                                                    ? _c(
                                                                                        "v-list-item",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              dense:
                                                                                                "",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.sendReplayRequestWithCompletedReferences(
                                                                                                  _vm
                                                                                                    .selectedJob[0]
                                                                                                    .id,
                                                                                                  ad.id,
                                                                                                  true,
                                                                                                  event.id
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-list-item-title",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Replay with Completed References"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getEventType(
                                                                              event.activityEventTypeId
                                                                            )
                                                                          ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            event.activityEventTypeId ===
                                                                              _vm
                                                                                .ActivityEventType
                                                                                .Started
                                                                              ? " (" +
                                                                                  event.id +
                                                                                  ")"
                                                                              : ""
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-right",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.displayEventDT(
                                                                              event
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _vm.getMaxTelemetryTime(
                                                                        event
                                                                      ) &&
                                                                      event ===
                                                                        _vm.selectedEvent
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "text-caption",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "hourglass_empty"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.getMaxTelemetryTime(
                                                                                      event
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }),
                                    _c(
                                      "div",
                                      { staticClass: "ml-3 mt-2" },
                                      [
                                        ad.events.length < ad.totalEventCount &&
                                        ad.totalEventCount > 500 &&
                                        _vm.loadingPhaseAndDefEvents
                                          ? _c("v-progress-circular", {
                                              attrs: {
                                                indeterminate: "",
                                                size: 10,
                                                width: 2,
                                                color: "primary",
                                              },
                                            })
                                          : _vm._e(),
                                        ad.events.length < ad.totalEventCount &&
                                        ad.totalEventCount > 500
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "informational-button",
                                                attrs: {
                                                  text: "",
                                                  "x-small": "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mr-6" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          ad.events.length +
                                                            "/" +
                                                            ad.totalEventCount
                                                        ) +
                                                        " Events "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        ad.events.length < ad.totalEventCount &&
                                        ad.totalEventCount > 500
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "text--secondary ml-1",
                                                attrs: {
                                                  text: "",
                                                  "x-small": "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.loadMoreEvents(
                                                      ad
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" More ... ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }